import Vue from 'vue';
import Cookies from 'js-cookie';
import $ from 'jquery';

import helpers from '@/helpers';
import components from '@/components';
import config from '@/config';
import plugins from '@/plugins';

config.init();
plugins.init();

new Vue({ // eslint-disable-line
    el: '#app',
    components,
    data() {
        return {
            showMenu: false,
            showMiniCart: false,
            addedToCart: false,
            showTopBar: !Cookies.get('hideTopBar'),
        };
    },
    created() {
        const vCloak = document.querySelectorAll('[v-cloak]');

        vCloak.forEach(item => item.removeAttribute('v-cloak'));
    },
    mounted() {
        helpers.init();
        this.showMinicartOnATC();
        this.removeClassOnHeaderScroll();
    },
    methods: {
        removeClassOnHeaderScroll() {
            $(window).scroll(() => {
                const scroll = $(window).scrollTop();
                if (scroll >= 20) {
                    $('.header').addClass('is-scrolled');
                    $('.js-header').removeClass('is-overlay');
                } else {
                    $('.header').removeClass('is-scrolled');
                    $('.js-header').addClass('is-overlay');
                }
            });
        },

        hideTopBar() {
            Cookies.set('hideTopBar', true);
            this.showTopBar = false;
        },

        hideMiniCart() {
            if (this.showMiniCart) {
                this.showMiniCart = false;
            }
        },

        menuClose() {
            this.showMenu = false;

            // Needed because not everything is wrapped inside Vue container
            document.body.classList.remove('show-menu');
        },

        menuItemToggle({ currentTarget }) {
            currentTarget.parentElement.classList.toggle('open');
        },

        menuToggle() {
            if (!this.showMenu) {
                this.savedScrollOffset = window.pageYOffset;
            }

            this.showMenu = !this.showMenu;

            // Needed because not everything is wrapped inside Vue container
            document.body.classList.toggle('show-menu');
        },

        showMinicartOnATC() {
            const addToCartButton = document.querySelectorAll(['.ajax_add_to_cart', '.single_add_to_cart_button']);
            addToCartButton.forEach((button) => {
                button.addEventListener('click', (e) => {
                    const target = e.currentTarget;
                    const addedToCart = setInterval(() => {
                        if (target.classList.contains('added')) {
                            this.showMiniCart = true;
                            this.addedToCart = true;
                            window.scrollTo(0, 0);
                            clearInterval(addedToCart);
                        }
                    }, 100);
                });
            });
        },
    },
});
